/** Marathi UI strings (merged over English in translations.js). */
export const rawMr = {
  nav: {
    home: "मुख्यपृष्ठ",
    database: "स्कॅमर डेटाबेस",
    recovery: "पुनर्प्राप्ती प्रक्रिया",
    risk: "धोका तपासणी",
    redFlags: "लाल झेंडे",
    education: "जागरूकता",
    stories: "खऱ्या कथा",
    about: "आमच्याबद्दल",
    contact: "संपर्क",
    legalHelp: "कायदेशीर मदत",
    reportCta: "तोट्याची तक्रार",
    mentors: "मेंटर",
    dashboard: "डॅशबोर्ड",
    signIn: "साइन इन",
    signOut: "साइन आउट",
  },
  common: {
    reportScam: "तोट्याची तक्रार",
    learnRecovery: "तक्रार प्रक्रिया जाणून घ्या",
    confidential: "१००% गोपनीय",
    readMore: "अजून वाचा",
    backHome: "मुख्यपृष्ठावर परत",
    search: "शोधा",
    verified: "पडताळलेले",
    anonymous: "अनामिक",
    submit: "सादर करा",
    cancel: "रद्द",
    requiredField: "आवश्यक",
    check: "आत्ता तपासा",
    loading: "लोड होत आहे…",
    error: "काहीतरी चुकले. पुन्हा प्रयत्न करा.",
  },
  hero: {
    eyebrow: "भारताचे पुरावा-आधारित आर्थिक तक्रार मार्गदर्शन",
    title1: "आर्थिक तोट्याशी",
    title2: "लढा.",
    subtitle:
      "ट्रेडिंग फसवणूक ते बँकिंग, सायबर, विमा, एअरलाइन, ग्राहक, गृहवित्त आणि निवृत्तीवेतन वाद — योग्य प्राधिकरण, योग्य पुरावा आणि अधिकृत भारतीय तक्रार प्रणालीद्वारे योग्य पुढचे पाऊल.",
    reportBtn: "आर्थिक तोटा नोंदवा",
    recoveryBtn: "तक्रार प्रक्रिया जाणून घ्या",
    taglines: ["योग्य प्राधिकरण शोधा.", "योग्य पुरावा तयार करा.", "योग्य पाऊल उचला."],
  },
  report: {
    title: "अनामिकपणे तक्रार नोंदवा",
    subtitle: "तुमची ओळख पूर्ण गोपनीय राहते. प्रकाशनापूर्वी प्रत्येक तक्रार तपासली जाते.",
    scamType: "तोट्याचा प्रकार",
    amountLost: "तोट्याची रक्कम (₹)",
    platform: "वापरलेले प्लॅटफॉर्म",
    telegram: "टेलिग्राम युजरनेम (असल्यास)",
    upi: "UPI ID (असल्यास)",
    phone: "फोन नंबर (असल्यास)",
    company: "कंपनी / सल्लागाराचे नाव",
    website: "वेबसाइट URL",
    description: "काय झाले — तपशीलवार लिहा",
    contact: "ईमेल (पर्यायी)",
    uploadEvidence: "पुरावा अपलोड",
    uploadHelp: "स्क्रीनशॉट, PDF, पेमेंट पुरावा, चॅट एक्सपोर्ट. फाइल दर १०MB.",
    submit: "सुरक्षितपणे सादर करा",
    successTitle: "तक्रार सादर झाली",
    successDesc: "धन्यवाद. ७२ तासांत आमची टीम पुरावा तपासेल. तुमची ओळख गोपनीय राहील.",
    disclaimer: "प्रत्येक आरोपासाठी पुरावा आवश्यक. खोट्या तक्रारी नाकारल्या जाऊ शकतात.",
  },
  education: {
    eyebrow: "शिका · संरक्षण · पुनर्प्राप्ती",
    title: "जागरूकता केंद्र",
    subtitle: "भारतीय गुंतवणूकदारांसाठी फसवणूक जागरूकता आणि कायदेशीर मार्गदर्शन.",
    readMinutes: "मिनिटे वाचा",
    filterAll: "सर्व",
    emptyCategory: "या श्रेणीत अद्याप लेख नाहीत.",
  },
  blog: {
    eyebrow: "तपास · कथा · मार्गदर्शक",
    title: "ब्लॉग — खरे प्रकरण, कायदेशीर मार्ग",
    subtitle: "पडताळलेल्या पीडितांचे अनुभव आणि कायदेशीर तक्रारीची पावले.",
    allStories: "सर्व कथा",
    featured: "वैशिष्ट्यीकृत",
    readFull: "संपूर्ण वाचा",
    readArticle: "संपूर्ण लेख",
    collapse: "संक्षिप्त",
    emptyCategory: "या श्रेणीत अद्याप लेख नाहीत.",
    newBadge: "नवीन",
  },
  footer: {
    tagline: "अफवा नाही, पुरावा. शांतता नाही, सुरक्षा.",
    sections: { platform: "प्लॅटफॉर्म", legal: "कायदेशीर", connect: "जोडा" },
    links: {
      privacy: "गोपनीयता धोरण",
      terms: "वापर अटी",
      disclaimer: "अस्वीकरण",
      antiHarassment: "छळ-विरोधी धोरण",
      dataDeletion: "डेटा हटवण्याची विनंती",
    },
    disclaimer: "CHINTAMAT आर्थिक सल्ला देत नाही. पुनर्प्राप्तीची हमी देत नाही.",
    rights: "© २०२६ CHINTAMAT. सार्वजनिक हिताचे फसवणूक-विरोधी मिशन.",
  },
  stats: {
    reports: "पडताळलेल्या तक्रारी",
    scammers: "ट्रॅक केलेले फसवणूक",
    cases: "सोडवलेली प्रकरणे",
    loss: "नोंदवलेला तोटा",
  },
};

export const appStringsMr = {
  lang: { choose: "भाषा निवडा" },
  auth: {
    welcomeBack: "पुन्हा स्वागत",
    signInSubtitle: "रिव्ह्यू, केस ट्रॅक आणि मेंटर सेव्ह करण्यासाठी साइन इन करा.",
    joinTitle: "CHINTAMAT मध्ये सामील व्हा",
    joinSubtitle: "स्कॅम तक्रार, कायदेशीर मदत आणि मेंटर डिरेक्टरीसाठी खाते तयार करा.",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "पूर्ण नाव",
    signIn: "साइन इन",
    signUp: "खाते तयार करा",
    continueGoogle: "Google सह सुरू ठेवा",
    orEmail: "किंवा ईमेल",
    newHere: "CHINTAMAT वर नवीन?",
    haveAccount: "आधीच खाते आहे?",
    createAccount: "खाते तयार करा",
    gotoSignIn: "साइन इन",
    passwordMin: "पासवर्ड किमान ६ अक्षरे",
    roleUser: "वैयक्तिक",
    roleUserDesc: "ट्रेडर / पीडित — तक्रार किंवा संशोधनासाठी.",
    roleMentor: "मेंटर / शिक्षक",
    roleMentorDesc: "कोर्स, चॅनेल किंवा पेड मेंटरशिप चालवतो/ते.",
    roleAdvisory: "संशोधन विश्लेषक / सल्लागार",
    roleAdvisoryDesc: "SEBI-नोंदणीकृत RIA, RA किंवा फर्म.",
    verifying: "सत्र तपासणी…",
    adminRequired: "अॅडमिन प्रवेश आवश्यक.",
  },
  dashboard: {
    eyebrow: "माझा डॅशबोर्ड",
    hello: "नमस्कार",
    adminPanel: "अॅडमिन पॅनेल",
    adminDesc: "वापरकर्ते, स्कॅम तक्रारी, कायदेशीर मदत आणि ब्लॉग व्यवस्थापित करा.",
    openAdmin: "अॅडमिन उघडा",
    statReviews: "लिहिलेले रिव्ह्यू",
    statCases: "नोंदवलेले केस",
    statLegal: "कायदेशीर विनंती",
    statSaved: "सेव्ह केलेले मेंटर",
    tabReviews: "माझे रिव्ह्यू",
    tabCases: "माझे केस",
    tabSaved: "सेव्ह मेंटर",
    tabLegal: "कायदेशीर मदत",
    emptyReviews: "अद्याप रिव्ह्यू नाहीत.",
    browseMentors: "मेंटर पहा",
    emptyCases: "अद्याप केस नाहीत.",
    reportScam: "तोटा नोंदवा",
    emptySaved: "सेव्ह मेंटर नाहीत.",
    discoverMentors: "मेंटर शोधा",
    emptyLegal: "अद्याप कायदेशीर विनंती नाही.",
    submitLegal: "विनंती पाठवा",
    viewProfile: "प्रोफाइल",
    recentActivity: "अलीकडील अपडेट",
    openCase: "केस उघडा",
    prefsTitle: "सूचना प्राधान्ये",
    prefsBlog: "नवीन ब्लॉग आणि शिक्षण लेख",
    prefsCase: "केस स्थिती आणि स्टाफ उत्तर",
    prefsSaved: "प्राधान्ये जतन",
  },
  notifications: {
    title: "सूचना",
    empty: "अद्याप सूचना नाहीत",
    markAllRead: "सर्व वाचले म्हणून चिन्हांकित",
    viewDashboard: "डॅशबोर्ड उघडा",
    types: {
      case_status_change: { title: "{caseLabel} — स्थिती अपडेट", body: "तुमचा केस आता: {status}" },
      case_staff_comment: { title: "CHINTAMAT कडून उत्तर", body: "{authorName}: {preview}" },
      case_user_comment: { title: "वापरकर्ता टिप्पणी — {caseLabel}", body: "{authorName}: {preview}" },
      new_scam_report: { title: "नवीन स्कॅम तक्रार", body: "{scamType}" },
      new_legal_request: { title: "नवीन कायदेशीर विनंती", body: "{lossType} — {name}" },
      blog_published: { title: "नवीन लेख", body: "{articleTitle}" },
    },
  },
  caseWorkspace: {
    evidenceTitle: "पुरावा चेकलिस्ट",
    statusTimeline: "स्थिती वेळरेषा",
    comments: "टिप्पण्या",
    sendMessage: "संदेश पाठवा",
    postComment: "टिप्पणी पोस्ट",
    noComments: "अद्याप टिप्पण्या नाहीत. CHINTAMAT स्टाफ येथे उत्तर देईल.",
    userCommentHint: "तुमचा संदेश CHINTAMAT स्टाफला दिसेल.",
    staffCommentHint: "सार्वजनिक टिप्पण्या वापरकर्त्याला दिसतात. अंतर्गत नोट्स फक्त स्टाफसाठी.",
    publicVis: "सार्वजनिक (वापरकर्ता पाहू शकतो)",
    internalVis: "फक्त अंतर्गत",
    loading: "केस लोड…",
    notFound: "केस सापडला नाही",
    caseUpdated: "केस अपडेट",
    commentPosted: "टिप्पणी पोस्ट",
    checklist: {
      screenshots: "चॅट किंवा स्क्रीनशॉट पुरावा",
      payment_proof: "UPI / बँक पेमेंट पुरावा",
      platform_profile: "फसवणूक प्रोफाइल लिंक",
      contract: "चलन किंवा करार",
    },
  },
  mentors: {
    title: "मेंटर डिरेक्टरी",
    subtitle: "पेमेंटपूर्वी मेंटर तपासा. रिव्ह्यू नोंदणीकृत वापरकर्त्यांकडून — SEBI नोंदणी स्वतंत्र पडताळा.",
    search: "नाव, कंपनी, शहर शोधा…",
    category: "श्रेणी",
    allCategories: "सर्व श्रेणी",
    verification: "पडताळणी",
    all: "सर्व",
    verifiedOnly: "फक्त पडताळलेले",
    unverified: "अपडताळलेले",
    sortTrust: "सर्वोच्च विश्वास",
    sortReviews: "सर्वाधिक रिव्ह्यू",
    sortRecent: "अलीकडील",
    noResults: "मेंटर सापडले नाहीत.",
    viewProfile: "प्रोफाइल",
    reviews: "रिव्ह्यू",
  },
  protected: { loading: "सत्र तपासणी…", adminLoading: "अॅडमिन तपासणी…" },
};
